// import profile images
import ProfilePhoto1 from '../src/assets/img/profile1.png';
import ProfilePhoto2 from '../src/assets/img/profile2.png';
import ProfilePhoto3 from '../src/assets/img/profile3.png';

// import about icons
import Skill1 from '../src/assets/img/skills/skill1.png';
import Skill2 from '../src/assets/img/skills/skill3.png';

// import team images
import TeamMember1 from '../src/assets/img/lawyer1.png';
import TeamMember2 from '../src/assets/img/lawyer2.png';
import TeamMember3 from '../src/assets/img/lawyer3.png';

// import social icons
import FacebookIcon from '../src/assets/img/social/facebook.png';
import TwitterIcon from '../src/assets/img/social/twitter.png';
import InstagramIcon from '../src/assets/img/social/instagram.png';
// import YoutubeIcon from '../src/assets/img/social/youtube.png';
// import PinterestIcon from '../src/assets/img/social/pinterest.png';

// navigation data
export const navigation = [
  {
    name: 'Home',
    href: 'home',
  },
  {
    name: 'About us',
    href: 'about',
  },
  {
    name: 'Services we offer',
    href: 'skills',
  },
  {
    name: 'Contact us',
    href: 'contact',
  },
];

// testimonials data
export const testimonials = [
  {
    text: 'CYD was very patient and helpful and handled everything on my behalf. She was also cooperative when I called her the next day to ask something. No hassle whatsoever, everything went smoothly.',
    name: 'Jane Cruz',
    image: ProfilePhoto1,
    position: 'Technology Solutions Company',
  },
  {
    text: 'A friend of mine recommended Cyd to me and couldnt believe how fast she wrote my contract. I am more than happy with the service she provided.',
    name: 'Theresa Santos',
    image: ProfilePhoto2,
    position: 'Property Owner',
  },
  {
    text: 'The team is very professional and helpful. I would recommend their services to all my family and friends who needs help with Documents Drafting.',
    name: 'Kathryn Reyes',
    image: ProfilePhoto3,
    position: 'Property Owner',
  },
  {
    text: 'They helped me with the documents for my business, I also needed specific terms and conditions and they quickly wrote them for me. Thumbs up!',
    name: 'Ruby dela Cruz',
    image: ProfilePhoto1,
    position: 'Heathfield Company',
  },
  {
    text: 'I dont hesitate to recommend CYD, they do what they say, the fees do not increase and I dont have to chase them.',
    name: 'Michelle Bautista',
    image: ProfilePhoto2,
    position: 'Property Owner',
  },
  {
    text: 'I asked Cyd to review a contract and provide me with legal advice. They were so helpful! I was surprised by the level of service I received. I am so happy with the outcome! They only charged a small fixed fee which was great!',
    name: 'Leny Garcia',
    image: ProfilePhoto3,
    position: 'Go Team Inc.',
  },
];


// skills data
export const skills = [
  {
    icon: Skill1,
    title: 'Documentation Services',
    description:
      'Providing reliable services, offering trustworthy & accurate documentation that meets your needs.',
    service1: 'Affidavits',
    service2: 'Deed of Sale',
    service3: 'Contract to Sell',
    service4: 'Lease of Contract',
    service5: 'Memorandum of Agreements',
    service6: 'Special Power of Attorney',
  },
  {
    icon: Skill2,
    title: 'Property Management Services',
    description:
      'We offer professional services to property owners to help manage your real estate investments.',
    service1: 'Consulting',
    service2: 'Titling',
    service3: 'Transfer of Titles',
    service4: 'Settlement of Estates',
    service5: 'Assumption of Mortgage',
    service6: 'Administration of Estate',
},
];

// team data
export const team = [
  {
    image: TeamMember1,
    name: 'Jane William',
    position: 'Band & Financial Lawyer',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed erat nibh tristique ipsum.',
  },
  {
    image: TeamMember2,
    name: 'Andrea Collins',
    position: 'Family Lawyer',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed erat nibh tristique ipsum.',
  },
  {
    image: TeamMember3,
    name: 'John Smith',
    position: 'Business Lawyer',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed erat nibh tristique ipsum.',
  },
];

// social data
export const social = [
  {
    icon: FacebookIcon,
    href: 'https://web.facebook.com/tinaborre',
  },
  {
    icon: TwitterIcon,
    href: '#',
  },
  {
    icon: InstagramIcon,
    href: 'home',
  },
];

